module.exports = __webpack_public_path__ + "static/media/galerija_2021 (31)-min.bd7dddd8.jpg";